module.exports = __webpack_public_path__ + "img/32-02.31ce68e7.png";